import { call, put, takeLatest } from 'redux-saga/effects';
import {
  fetchApprovedProducts,
  fetchApprovedProductsSuccess,
  fetchApprovedProductsFailure,
} from '../slices/approvedProducts.slice';
import {
  fetchApprovedProducts as fetchApprovedProductsApi,
  IApprovedProductsResponse,
} from '@/services/standalone/approvedProducts';
import { SagaIterator } from 'redux-saga';
import { isBoolean } from 'lodash';

function* handleFetchApprovedProducts(
  action: ReturnType<typeof fetchApprovedProducts>
): SagaIterator {
  try {
    const response: { data: IApprovedProductsResponse } = yield call(
      fetchApprovedProductsApi,
      action.payload
    );

    if (isValidApprovedProductsSuccessResponse(response.data)) {
      yield put(fetchApprovedProductsSuccess(response.data));
    } else {
      yield put(
        fetchApprovedProductsFailure(
          response.data?.message || 'Failed to fetch Approved Products'
        )
      );
    }
  } catch (error: any) {
    yield put(
      fetchApprovedProductsFailure(
        error?.response?.data?.message ||
          error?.message ||
          'Failed to fetch Approved Products'
      )
    );
  }
}

function isValidApprovedProductsSuccessResponse(
  response: IApprovedProductsResponse
): boolean {
  return isBoolean(response?.success) && response.success === true;
}

export default function* approvedProductsSaga() {
  yield takeLatest(fetchApprovedProducts.type, handleFetchApprovedProducts);
}
